module.exports = __webpack_public_path__ + "img/the-logo-welcome.d9395d50.png";